module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN206_1565680216.a32efb38.png";